module.exports = __webpack_public_path__ + "static/media/6.c3ff53eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/6.png
// module id = 483
// module chunks = 0